import React from "react";

import TextInput from "../../components/common/inputs/textInput";
import ToggleInput from "../../components/common/inputs/toggleInput";
import Loading from "../../components/common/loading";
import ModalManager from "../../components/common/modal/ModalManager";
import axios from "axios";
import PDUAccessDropdown from "../../components/users/pduAccessDropdown";
import NotificationManager from "../../utils/notificationManager";
import ButtonInput from "../../components/common/inputs/buttonInput";
import {
  AppCard,
  AppContextBanner,
  AppPage,
  AppPageHeader,
} from "../../components/common/appShell";
import SubHeader from "../../components/common/topHeader/subHeader";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import SelectInput from "../../components/common/inputs/selectInput";
import NotFoundPage from "../notFound";

import "./teamMemberDevices.css";

const USER_DEVICES_PAGE_SIZE = 12;

function normalizeSerial(value) {
  return value === undefined || value === null ? "" : String(value);
}

function groupContainsDevice(group, enclosureSerialNumber) {
  const serial = normalizeSerial(enclosureSerialNumber);
  return (group?.items || []).some((item) => {
    if (item && typeof item === "object") {
      return normalizeSerial(item.item_id ?? item.id ?? item.enclosureSerialNumber) === serial;
    }
    return normalizeSerial(item) === serial;
  });
}

function getRoleName(roles = [], roleId) {
  return roles.find((role) => role.id == roleId)?.name || "";
}

function getDeviceSeries(device = {}) {
  if (!device.modelNumber) {
    return "";
  }

  if (device.outletPwrMeasurementsSupported && device.outletSwitchingSupported) {
    return "SynLink Switched Pro+";
  }

  if (!device.outletPwrMeasurementsSupported && !device.outletSwitchingSupported) {
    return "SynLink Monitored";
  }

  if (device.inletCurrentSupported && device.outletSwitchingSupported) {
    return device.modelNumber.startsWith("NP") ? "NetBooter" : "SynLink Switched";
  }

  return "";
}

function getDeviceModelCode(device = {}) {
  if (!device.modelNumber) {
    return "-";
  }
  return device.modelNumber.startsWith("NP") ? device.modelNumber : `SP-${device.modelNumber}`;
}

function getDeviceModelLine(device = {}) {
  if (!device.modelNumber) {
    return "-";
  }
  const series = getDeviceSeries(device);
  const formFactor = series === "NetBooter" ? "" : device.formFactor || "";
  const productSuffix = series === "NetBooter" ? " PDU" : "";
  const lteSuffix = device.modelNumber.endsWith("M01") ? " LTE" : "";
  return `${formFactor} ${series}${productSuffix}${lteSuffix}`.trim();
}

function isDeviceOnline(device = {}) {
  const connectionState = String(device.connectionState || "").toLowerCase();
  return connectionState === "connected" || connectionState === "online";
}

function formatLastHeard(value) {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleString();
}

function getPasswordInviteStatus({
  enterpriseRequiresSso,
  passwordLoginDisabled,
  hasPassword,
}) {
  if (enterpriseRequiresSso || passwordLoginDisabled || hasPassword) {
    return null;
  }

  return {
    label: "Invite pending",
    color: "#92400e",
    background: "rgba(217, 119, 6, 0.15)",
    description:
      "No password is set yet. Send the setup email if this user needs another invite link.",
  };
}


export default class UserTeamMemberItem extends React.Component {
  componentDidMount() {
    if (!this.props.resources.groupsLoaded && !this.props.resources.groupsLoading) {
      this.props.fetchResource("groups")
    }
    if (!this.props.resources.rolesLoaded && !this.props.resources.rolesLoading) {
      this.props.fetchResource("roles")
    }
  }
  render() {

    const foundUser = (this.props.resources.userEnterprise?.users || []).find(
      (user) => user.user_id == this.props.match.params.userId
    );

    const sections = [{
      label: "Settings",
      icon: "person",
      path: `/team/members/${this.props.match.params.userId}/settings`,
      component: UserSettings,
      props: {
        ...this.props
      }
      
    // }, {
    //   label: "Groups",
    //   icon: "group",
    //   path: `/team/members/${this.props.match.params.userId}/groups`,
    //   component: UserGroups,
    //   props: {
    //     ...this.props
    //   }
    }, {
      label: "Devices",
      icon: "devices",
      path: `/team/members/${this.props.match.params.userId}/devices`,
      component: UserDevices,
      props: {
        ...this.props
      }
    }, {
      label: "Privileges",
      icon: "lock",
      path: `/team/members/${this.props.match.params.userId}/privileges`,
      component: UserPrivileges,
      props: {
        ...this.props
      }

    }]

    return (
      <div>
        <SubHeader
          sections={sections.filter(s => !s.disabled)}
        />
        <AppContextBanner
          label="Team member"
          title={foundUser?.email_id}
          description="Review settings, device access, and role assignments for this team member."
        />
        <div style={{ marginTop: "16px"}}>
          <Switch>
            {sections &&
              sections.map((section) => {
                return (
                  <Route
                    key={section.label}
                    path={section.path}
                    exact={section.exact === undefined ? true : section.exact}
                    render={(props) => {
                      // const CompToRender = scrollTopOnMount(section.component);
                      const CompToRender = section.component;
                      return (
                        <CompToRender
                          {...(section.props || {})}
                          match={this.props.match}
                        />
                      );
                    }}
                  />
                );
              })}
            {sections && (
              <Route exact path={`/team/members/${this.props.match.params.userId}`}>
                <Redirect to={`/team/members/${this.props.match.params.userId}/settings`} />
              </Route>
            )}
            <Route
              render={(props) => (
                <NotFoundPage
                  {...props}
                  homePath={`/team/members/${this.props.match.params.userId}/settings`}
                  homeLabel="Go to member settings"
                />
              )}
            />
          </Switch>

        </div>
      </div>
    )
  }
}

class UserSettings extends React.Component {
  state = {
    user_id: "",
    active_in_enterprise: false,
    email_id: "",
    full_name: "",
    company: "",
    email_verified: false,
    approved: false,
    has_admin_privileges: false,
    password_login_disabled: false,

    enterprise: {},
    pdu_access_list: [],
    password: "",

    hasChanges: false,
    loading: false,
  };
  componentDidMount = async () => {
    this.setState({
      loading: true,
    });
    axios
      .get(`/v1/users/${this.props.match.params.userId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
          

        this.setState({
          ...((res.data || {}).data || {}),
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  deleteUser = () => {
    ModalManager.confirm(
      "This will delete the user permanently",
      "Are you sure you want to delete this user?",
      "Delete",
      (submitted, close) => {
        if (submitted) {
          close();
          axios
            .delete(`/v1/users/${this.state.user_id}`, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then((res) => {
              NotificationManager.success("User Deleted", "Success");
              this.props.history.push("/team/members");
              this.props.updateFetchWrapperState({
                userEnterprise: {
                  ...this.props.resources.userEnterprise,
                  users: this.props.resources.userEnterprise.users.filter(
                    (user) => user.user_id != this.state.user_id
                  ),
                }
              })
            })
            .catch((err) => {
              NotificationManager.alert("Error deleting user", "Error");
            });
        }
      }
    );
  }

  onSave = () => {
    let pdu_access_list = this.state.pdu_access_list
    if (this.state.pdu_access_list && (this.state.pdu_access_list.length === 1) && this.state.pdu_access_list[0] === "All PDUs") {
      pdu_access_list = []
    }
    axios.put(`/v1/users/${this.state.user_id}`, {
      email_verified: this.state.email_verified,
      approved: this.state.approved,
      active_in_enterprise: this.state.active_in_enterprise,
      has_admin_privileges: this.state.has_admin_privileges,
      pdu_access_list: pdu_access_list,
      password_login_disabled: this.state.password_login_disabled,
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then((res) => {
      NotificationManager.success("User updated", "Success");
      this.setState({
        hasChanges: false,
      });
      this.props.updateFetchWrapperState({
          userEnterprise: {
            ...this.props.resources.userEnterprise,
            users: this.props.resources.userEnterprise.users.map((user) => {
              if (user.user_id === this.state.user_id) {
                return {
                  ...user,
                  ...this.state,
                };
              }
              return user;
            }),
          }
      })
    })
    .catch((err) => {
      NotificationManager.alert("Error updating user", "Error");
      console.log(err);
    });

  };
  changePassClick = () => {
    ModalManager.confirm(
      "",
      !!this.state.password ? `Change Password` : "Set Password",
      // "",
      "",
      (submitted, close) => {
        if (submitted) {
          close();
        }
      },
      ({ close }) => (
        <ChangePasswordForm
          close={close}
          user={this.state}
          resetPassword={this.props.resetPassword}
          passwordExists={!!this.state.obscuredPassword}
        />
      ),
      true,
      true
    );
  };

  requestEnterpriseSetupEmail = () => {

    ModalManager
    .confirm(
      "Send a password setup email to the following user. ",
      "Send Setup Email",
      "Send email",
      (status, close) => {
        if (status) { // clicked sign in
          const enterpriseId = this.props.resources.userEnterprise?.id
          if (!enterpriseId) {
            NotificationManager.alert(`Error occurred sending email`);
            return;
          }
          const userId = this.props.match.params.userId;
          axios
          .post(
            `/v1/enterprises/${enterpriseId}/users/${userId}/invite`,
            {},
            {
              headers: {
                authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            // alert("Email sent")
            if (res.status == 200) {
              NotificationManager.success(`Setup Email sent successfully`);
            } else {
              NotificationManager.alert(`Error occurred sending email.`);
            }
          })
          .catch((err) => {
            console.log(err);
            NotificationManager.alert(`Error occurred sending email`);
          });
          close();

        } else { // clicked cancel or outside

        }
      },
      null,
      true
    )
  };
  render() {
    const {
      user_id,
      active_in_enterprise,
      email_id,
      email_verified,
      approved,
      password_login_disabled,
      has_admin_privileges,
      loading
    } = this.state;
    if (!user_id || loading) {
      // return "User not found";
      return <Loading black />;
    }

    const userEnterprise = this.props.resources?.userEnterprise || {};
    const enterpriseRequiresSso = Boolean(userEnterprise.require_sso_for_sign_in);
    const effectivePasswordLoginDisabled =
      enterpriseRequiresSso || Boolean(password_login_disabled);
    const hasPassword = Boolean(this.state.obscuredPassword);
    const inviteStatus = getPasswordInviteStatus({
      enterpriseRequiresSso,
      passwordLoginDisabled: Boolean(password_login_disabled),
      hasPassword,
    });
    return (
      <AppPage>
        <AppPageHeader
          title="User settings"
          description="Approve access, manage sign-in methods, and define how this user participates in the team."
          actions={
            <button
              className="button"
              onClick={() => {
                if (!this.loading) {
                  this.onSave();
                }
              }}
              disabled={!this.state.hasChanges}
              style={{ opacity: this.state.hasChanges ? 1 : 0.6 }}
            >
              {this.state.loading ? <Loading /> : "Save changes"}
            </button>
          }
        />
        <div className="app-form-grid">
          <AppCard
            title="User information"
            description="Control verification, approval, password access, and one-time setup actions."
          >
            <TextInput label="Email" value={email_id} readOnly={true} />
            {inviteStatus ? (
              <div
                style={{
                  marginBottom: "20px",
                  padding: "12px 14px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "6px",
                  background: "var(--surface-subtle-color)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                    marginBottom: "6px",
                  }}
                >
                  <span
                    style={{
                      color: "var(--text-color)",
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    Invite status
                  </span>
                  <span
                    style={{
                      color: inviteStatus.color,
                      background: inviteStatus.background,
                      borderRadius: "999px",
                      fontSize: "11px",
                      fontWeight: 700,
                      padding: "4px 9px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {inviteStatus.label}
                  </span>
                </div>
                <div
                  style={{
                    color: "var(--text-muted-color)",
                    fontSize: "13px",
                    lineHeight: 1.4,
                  }}
                >
                  {inviteStatus.description}
                </div>
              </div>
            ) : null}
            <ToggleInput
              label={<div>Email verified <span style={{ color: "var(--text-muted-color)" }}>{userEnterprise.email_verification_required ? "(currently required)" : "(currently optional)"}</span></div>}
              description="Manually verify email if they are required for user access."
              value={email_verified}
              callback={(value) => {
                this.setState({
                  email_verified: value,
                  hasChanges: true,
                });
              }}
            />
            <ToggleInput
              label="Approved"
              description="Approve user to allow access to the system."
              value={approved}
              disabled={this.state.is_enterprise_admin}
              callback={(value) => {
                this.setState({
                  approved: value,
                  hasChanges: true,
                });
              }}
            />
            <ToggleInput
              label="Password sign-in disabled"
              description={
                enterpriseRequiresSso
                  ? "Password sign-in is disabled by enterprise SSO policy."
                  : "Disable email-and-password sign-in for this user."
              }
              value={effectivePasswordLoginDisabled}
              disabled={enterpriseRequiresSso}
              callback={(value) => {
                this.setState({
                  password_login_disabled: value,
                  hasChanges: true,
                });
              }}
            />
            <ButtonInput
              // label={"Reset Password " + this.state.obscuredPassword ? "" : "(Not set)"} 
              // label={`Reset Password ${this.state.obscuredPassword ? "" : "(Not currently set)"}`}
              label={<div>Reset password <span style={{ color: "var(--text-muted-color)" }}>{hasPassword ? "" : "(not currently set)"}</span></div>}
              description={
                effectivePasswordLoginDisabled
                  ? "Unavailable while password sign-in is disabled."
                  : undefined
              }
              buttonName="Change password"
              disabled={effectivePasswordLoginDisabled}
              buttonCallback={() => {
                this.changePassClick();
              }}
            />
            <ButtonInput
              label="Send user setup email"
              description={
                effectivePasswordLoginDisabled
                  ? "Unavailable while password sign-in is disabled."
                  : "Send a password setup email to the user."
              }
              buttonName="Send setup email"
              disabled={effectivePasswordLoginDisabled}
              buttonCallback={() => {
                this.requestEnterpriseSetupEmail();
              }}
            />
            <ButtonInput
              label="Delete user permanently"
              buttonName="Delete user"
              buttonStyle={{
                backgroundColor: "var(--danger-background)",
                color: "var(--danger-color)",
                borderColor: "rgba(153, 27, 27, 0.2)",
              }}
              buttonCallback={() => {
                this.deleteUser();
              }}
            />
          </AppCard>
          <AppCard
            title="Team settings"
            description="Control whether the user is active in the team, whether they have admin access, and which devices they can reach."
          >
            <TextInput label="Team" value={userEnterprise.name} readOnly={true} />
            <ToggleInput
              label="Active in team"
              description="Users that are inactive will not be able to login or access the allocated resources."
              value={active_in_enterprise}
              callback={(value) => {
                this.setState({
                  active_in_enterprise: value,
                  hasChanges: true,
                });
              }}
            />
            <ToggleInput
              label="Admin privileges"
              description="Admins will have the ability to modify SSO settings, change team settings, create/update/delete users, and manage PDU access to users. Only admins are allowed to create, edit, or delete groups."
              value={has_admin_privileges}
              callback={(value) => {
                this.setState({
                  has_admin_privileges: value,
                  hasChanges: true,
                });
              }}
            />
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                paddingBottom: "10px",
              }}
            >
              Device access list
            </div>
            <PDUAccessDropdown
              user={this.state}
              devices={this.props.resources.devices}
              devicesLoading={this.props.resources.devicesLoading}
              groups={this.props.resources.groups}
              pdu_access_list={this.state.pdu_access_list}
              onPduAccessListChange={(updatedPDUList) => {
                this.setState({
                  pdu_access_list: updatedPDUList,
                  hasChanges: true,
                });
              }}
            />
          </AppCard>
        </div>
      </AppPage>
    );
    
  }
}

class ChangePasswordForm extends React.Component {
  state = {
    password: "",
    confirmPassword: "",
    errorMsg: "",
    loading: false,
  };
  resetPasswordButtonPress = () => {
    this.setState({
      errorMsg: "",
      loading: true,
    });
    if (this.state.password === this.state.confirmPassword) {
      axios
        .put(
          `/v1/users/${this.props.user.user_id}/password`,
          {
            password: this.state.password,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.setState({
            loading: false,
          });
          this.props.close();
          NotificationManager.success("User Password Changed Successfully");
        })
        .catch((err) => {
          this.setState({
            loading: false,
            errorMsg: err?.response?.data?.message || "Error changing password",
          });
        });
    } else {
      this.setState({
        loading: false,
        errorMsg: "Passwords do not match",
      });
    }
  };

  render() {
    const { passwordExists } = this.props;
    return (
      <React.Fragment>
        <TextInput
          label="Password"
          callback={(text) => this.setState({ password: text })}
          value={this.state.password}
          inputContainerStyle={{
            width: "100%",
            marginBottom: "0px",
          }}
          type="password"
        />
        <TextInput
          label="Confirm Password"
          callback={(text) => this.setState({ confirmPassword: text })}
          value={this.state.confirmPassword}
          inputContainerStyle={{
            width: "100%",
            marginBottom: "0px",
          }}
          type="password"
        />
        <div
          style={{
            color: "maroon",
            padding: "10px 0px 20px 0px",
          }}
        >
          <div>
            {[
              {
                name: "2 lowercase characters required",
                valid: /[a-z].*[a-z]/.test(this.state.password),
              },
              {
                name: "2 uppercase characters required",
                valid: /[A-Z].*[A-Z]/.test(this.state.password),
              },
              {
                name: "2 number characters required",
                valid: /[0-9].*[0-9]/.test(this.state.password),
              },
              {
                name: "2 special characters required",
                valid: /[!@#$%^&*;].*[!@#$%^&*;]/.test(this.state.password),
              },
            ].map((validation) => {
              return (
                <div
                  key={validation.name}
                  style={{
                    color: validation.valid ? "forestgreen" : "#666",
                    display: "flex",
                    paddingBottom: "10px",
                    alignItems: "center",
                  }}
                >
                  <i className="material-icons">
                    {validation.valid ? "check" : "cancel"}
                  </i>
                  <span>{validation.name}</span>
                </div>
              );
            })}
          </div>
          {this.state.errorMsg &&
            this.state.errorMsg.split(",").map((msg) => {
              return (
                <div key={msg}>
                  <div
                    style={{
                      color: "maroon",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <i
                      className="material-icons"
                      style={{ marginRight: "5px" }}
                    >
                      error
                    </i>
                    <span>{msg}</span>
                  </div>
                </div>
              );
            })}
        </div>
        <button
          className="button"
          onClick={() => {
            this.resetPasswordButtonPress();
          }}
        >
          {this.state.loading ? <Loading /> : "Reset Password"}
        </button>
      </React.Fragment>
    );
  }
}



class UserGroups extends React.Component {
render() {
  return (
    <div>
      <h1>Groups</h1>
    </div>
  )
}
}

class UserPrivileges extends React.Component {
  state = {
    individualRoleId: "",
  }
  componentDidMount() {
    const foundUser = (this.props.resources.userEnterprise?.users || []).find(user => user.user_id == this.props.match.params.userId);
    if (foundUser) {
      this.setState({
        individualRoleId: foundUser.role_id,
      })
    }
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.resources.userEnterpriseLoaded && !prevProps.resources.userEnterpriseLoaded) {
      const foundUser = (this.props.resources.userEnterprise?.users || []).find(user => user.user_id == this.props.match.params.userId);
      if (foundUser) {
        this.setState({
          individualRoleId: foundUser.role_id,
        })
      }
    }
  //     if (this.props.resources.rolesLoaded && !prevProps.resources.rolesLoaded) {
  //         const foundRole = this.props.resources.roles.find(role => role.id == this.props.match.params.roleId);
  //         if (foundRole) {
  //             this.setState({individualRoleId: foundRole.id})
  //         }
  //     }
  }
  processIndividualRoleChange = (roleId) => {
    if (roleId === "create-new-role") {
      this.props.history.push("/team/roles/new");
    } else {
      ModalManager.confirm(
        "Are you sure you want to assign this role to this user?",
        "Confirm Role Assignment",
        "Confirm",
        (status, close) => {
          if (status) {
            axios.put(`/v1/users/${this.props.match.params.userId}`, {
              role_id: roleId,
            }, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              }
            }).then((res) => {
              NotificationManager.success("Role Assigned", "Success");
              this.props.updateFetchWrapperState({
                  userEnterprise: {
                    ...this.props.resources.userEnterprise,
                    users: this.props.resources.userEnterprise.users.map((user) => {
                      if (user.user_id == this.props.match.params.userId) {
                        return {
                          ...user,
                          role_id: roleId,
                        }
                      }
                      return user;
                    })
                }
              })
              this.setState({
                individualRoleId: roleId,
              })
              close();
            }).catch((err) => {
              NotificationManager.alert("Error assigning role", "Error");
              console.log(err);
            })

          }
        }
      )
    }
  };

  render() {
    const roles = this.props.resources.roles || [];
    const foundRole = roles.find(role => role.id == this.state.individualRoleId);

    const foundUser = (this.props.resources.userEnterprise?.users || []).find(user => user.user_id == this.props.match.params.userId);

    const userGroups = (foundUser?.pdu_access_list || []).filter(p => p.startsWith("Group:")).map(groupId => {
      return this.props.resources.groups.find(g => g.id == groupId.replace("Group:", ""));
    }).filter(g => !!g);

    const userGroupRoles = userGroups.map(g => {
      return ({
        role: roles.find(r => r.id == g.role_id),
        group: g
      })
    }).filter(r => !!r);

    return (
      <div>
          <h4>Roles</h4>
          <div style={{ marginBottom: "40px" }}>
          Roles are used to manage user permissions and restrict access privileges. They can be assigned either through groups or individually:
          <ul style={{ marginTop: "10px", marginBottom: "10px" }}>
            <li>
            <b>Group-based Roles</b>: When roles are assigned through groups, they apply to all users within that group and affect the devices the group has access to.

            </li>
            <li>
            <b>Individual Roles</b>: These are assigned to a single user and apply to all devices the user can access.
            </li>
          </ul>
            Role assignments are additive, meaning if a user has multiple roles for a specific PDU, they receive the combined permissions from all their roles. Individual roles will extend to all devices within the user's access range.
          </div>
            
          {!foundRole && (this.props.resources.userEnterpriseLoading ? (
            <Loading  black />
          ) : (
            <SelectInput
              label="Individual Role Assignment"
              // description="Assign a role to this user. Utilize roles to manage user permissions and restrict privileges."
              value={this.state.individualRoleId}
              callback={this.processIndividualRoleChange}
              defaultSelectText="Select a role"
              options={[
                ...roles.map((r) => ({
                  value: r.id,
                  label: r.name,
                })),
                {
                  label: "+ Create New Role",
                  value: "create-new-role"
                }
              ]}
            />
          ))}
          {/* <h4>Role Assignment granted from group</h4> */}
          <div className="grid-x">
            <div className="cell large-10 medium-10">
              <div className="grid-row header no-min-width">
                <div style={{ flex: 4 }}>Role</div>
                <div style={{ flex: 4 }}>Assignment</div>
                <div style={{ flex: 1 }}>Action</div>
              </div>
                {foundRole &&
                      <div className="grid-row no-min-width">
                        {/* <div style={{ flex: 4 }}>{foundRole.name}</div> */}
                <div style={{ flex: 4}}>
                  {this.props.resources.userEnterpriseLoading ? (
                    <Loading  black />
                  ) : (
                    <SelectInput
                      // label="Role Assigned"
                      value={this.state.individualRoleId}
                      callback={this.processIndividualRoleChange}
                      defaultSelectText={this.state.individualRoleId ? "No Role" : "No role assigned. Select a role"}
                      inputContainerStyle={{
                        margin: "0px",
                        padding: "0px",
                        marginRight: "10px"
                      }}
                      options={[
                        ...roles.map((r) => ({
                          value: r.id,
                          label: r.name,
                        })),
                        {
                          label: "+ Create New Role",
                          value: "create-new-role"
                        }
                      ]}
                    />
                  )}
                  </div>
                  <div style={{ flex: 4 }}>Individual</div>
                  <div style={{ flex: 1 }}>
                    {this.state.individualRoleId &&
                    // <span className="button" style={{
                    //   marginBottom: "0px"
                    // }}>
                    //   View
                    // </span>
                    <Link
                        to={`/team/roles/${this.state.individualRoleId}`}
                      >
                        <span className="button" style={{
                          marginBottom: "0px"
                        }}>
                          View
                        </span>
                      </Link>

                    }
                  </div>
                </div>
              }
              {userGroupRoles.map((userGroupRole, i) => {
                const role = userGroupRole.role;
                const group = userGroupRole.group;
                if (!role || !group) return null;
                return (
                  <div className="grid-row no-min-width" key={i}>
                    <div style={{ flex: 4 }}>{role.name}</div>
                    <div style={{ flex: 4 }}>Group: 
                      <Link to={`/devices/groups/${group.id}/users`}>
                        <span style={{
                          textDecoration: "underline",
                          paddingLeft: "3px"
                        }}>
                          {group.name}
                        </span>

                      </Link>
                    
                    </div>
                    <div style={{ flex: 1 }}>
                      <Link
                        to={`/team/roles/${role.id}`}
                      >
                        <span className="button" style={{
                          marginBottom: "0px"
                        }}>
                          View
                        </span>
                      </Link>
                    </div>
                  </div>
                )
              })}

            </div>
          </div>


      </div>
    )
  }
}



class UserDevices extends React.Component {
  state = {
    devices: [],
    currentPage: 1,
    pageSize: USER_DEVICES_PAGE_SIZE,
    userDevicesLoading: false,
  }
  
  componentDidMount() {
    this.setState({
      userDevicesLoading: true,
    });
    axios.get(`/v1/users/${this.props.match.params.userId}/devices`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    }).then((res) => {
      this.setState({
        devices: Array.isArray(res.data.data) ? res.data.data : [],
        currentPage: 1,
        userDevicesLoading: false,
      })
    }).catch((err) => {
      console.log(err);
      this.setState({
        userDevicesLoading: false,
      })  
    })
  }
  render() {

    const foundUser = (this.props.resources.userEnterprise?.users || []).find(user => user.user_id == this.props.match.params.userId);
    if (!foundUser) return <Loading black />
    const roles = this.props.resources.roles || [];
    const liveDevices = this.props.resources.devices || [];
    const accessListOrigins = (foundUser || {}).pdu_access_list || [];
    const groupAccessList = accessListOrigins.filter((a) => a.startsWith("Group:"));
    const deviceAccessList = accessListOrigins.filter((a) => a.startsWith("PDU:"));

    const groupAccessListFound = groupAccessList.map((a) => {
      const groupId = a.replace("Group:", "");
      return this.props.resources.groups.find((g) => (g || {}).id == groupId);
    }).filter((g) => !!g);
    const devices = this.state.devices.map((device) => {
      const foundLiveDevice = liveDevices.find(
        (liveDevice) => liveDevice.enclosureSerialNumber == device.enclosureSerialNumber,
      );
      return foundLiveDevice
        ? {
            ...foundLiveDevice,
            ...device,
            connectionState: device.connectionState || foundLiveDevice.connectionState,
            lastHeard: device.lastHeard || foundLiveDevice.lastHeard,
            deviceName: device.deviceName || foundLiveDevice.deviceName,
          }
        : device;
    });
    const totalDevices = devices.length;
    const onlineCount = devices.filter(isDeviceOnline).length;
    const offlineCount = totalDevices - onlineCount;
    const totalPages = Math.max(1, Math.ceil(totalDevices / this.state.pageSize));
    const currentPage = Math.min(this.state.currentPage, totalPages);
    const startIndex = totalDevices ? (currentPage - 1) * this.state.pageSize : 0;
    const visibleDevices = devices.slice(startIndex, startIndex + this.state.pageSize);
    const showingStart = totalDevices ? startIndex + 1 : 0;
    const showingEnd = Math.min(startIndex + this.state.pageSize, totalDevices);

    return (
      <div className="team-member-devices">
        <AppCard
          title="Devices"
          description="Devices this team member can access through direct assignment, device groups, or admin privileges."
          actions={
            <Link
              to={`/team/members/${this.props.match.params.userId}/settings`}
              className="button secondary team-member-devices__settings-link"
            >
              Manage Access
            </Link>
          }
        >
          <div className="team-member-devices__summary">
            <span><strong>{totalDevices}</strong> devices</span>
            <span><strong>{onlineCount}</strong> online</span>
            <span><strong>{offlineCount}</strong> offline</span>
          </div>
        </AppCard>

        <AppCard flush>
          {this.state.userDevicesLoading ? (
            <div className="team-member-devices__loading">
              {[0, 1, 2].map((item) => (
                <div className="team-member-devices__skeleton-row" key={item}>
                  <div className="skeleton-blank" />
                  <div className="skeleton-blank" />
                  <div className="skeleton-blank" />
                  <div className="skeleton-blank" />
                </div>
              ))}
            </div>
          ) : totalDevices === 0 ? (
            <div className="app-empty-state">No devices available for this team member.</div>
          ) : (
            <>
              <div className="team-member-devices__table-wrap">
                <table className="team-member-devices__table">
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Device</th>
                      <th>Status</th>
                      <th>Assignment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleDevices.map((device) => {
                      const online = isDeviceOnline(device);
                      const groupAssignments = groupAccessListFound.filter((group) =>
                        groupContainsDevice(group, device.enclosureSerialNumber),
                      );
                      const directAssignment = deviceAccessList.includes(
                        `PDU:${device.enclosureSerialNumber}`,
                      );
                      const userRoleName =
                        foundUser.role?.name || getRoleName(roles, foundUser.role_id);
                      const lastHeard = formatLastHeard(device.lastHeard);

                      return (
                        <tr key={device.id || device.enclosureSerialNumber}>
                          <td>
                            <Link
                              to={`/devices/connected/${device.enclosureSerialNumber}`}
                              className="team-member-devices__model-link"
                            >
                              {getDeviceModelCode(device)}
                            </Link>
                            <div className="team-member-devices__muted">
                              {getDeviceModelLine(device)}
                            </div>
                          </td>
                          <td>
                            <div className="team-member-devices__device-name">
                              {device.deviceName || device.last_known_name || "Unnamed device"}
                            </div>
                            <div className="team-member-devices__muted">
                              SN: {device.enclosureSerialNumber}
                            </div>
                          </td>
                          <td>
                            <span
                              className={`team-member-devices__status ${
                                online
                                  ? "team-member-devices__status--online"
                                  : "team-member-devices__status--offline"
                              }`}
                            >
                              {online ? "Online" : "Offline"}
                            </span>
                            {lastHeard ? (
                              <div className="team-member-devices__muted">
                                Last heard {lastHeard}
                              </div>
                            ) : null}
                          </td>
                          <td>
                            <div className="team-member-devices__assignments">
                              {(foundUser.has_admin_privileges || foundUser.is_enterprise_admin) ? (
                                <span className="team-member-devices__assignment-chip">
                                  Admin Privileges
                                </span>
                              ) : accessListOrigins.length === 0 ? (
                                <span className="team-member-devices__assignment-chip">
                                  Full Access
                                </span>
                              ) : null}
                              {groupAssignments.map((group) => {
                                const roleName = getRoleName(roles, group.role_id);
                                return (
                                  <Link
                                    className="team-member-devices__assignment-chip"
                                    key={group.id}
                                    to={`/devices/groups/${group.id}`}
                                  >
                                    {group.name}
                                    {roleName ? ` - ${roleName}` : ""}
                                  </Link>
                                );
                              })}
                              {directAssignment ? (
                                <span className="team-member-devices__assignment-chip">
                                  Assigned Directly{userRoleName ? ` - ${userRoleName}` : ""}
                                </span>
                              ) : null}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="team-member-devices__pagination">
                <span>
                  Showing {showingStart}-{showingEnd} of {totalDevices} devices
                </span>
                <div className="team-member-devices__pagination-actions">
                  <button
                    type="button"
                    className="button secondary"
                    disabled={currentPage <= 1}
                    onClick={() =>
                      this.setState({ currentPage: Math.max(currentPage - 1, 1) })
                    }
                  >
                    Previous
                  </button>
                  <span className="team-member-devices__page-count">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    type="button"
                    className="button secondary"
                    disabled={currentPage >= totalPages}
                    onClick={() =>
                      this.setState({
                        currentPage: Math.min(currentPage + 1, totalPages),
                      })
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </AppCard>
      </div>
    )
  }
}
